<template>
  <div>
    <v-row>
      <v-col cols="6">
        <p class="overline mb-2 text-uppercase">BETYG BIFOGADE AV LÄRLING</p>
        <div
          class="attachment mb-2"
          v-for="c in gradeDocs"
          :key="c.id"
        >
          <v-icon class="flex-grow-0 flex-shrink-0">$sl-file</v-icon>
          <div class="flex-grow-1 flex-shrink-1 attachment-link">
            <a
              v-if="c && c.fileName && c.internalFileName"
              @click="$emit('get-document', c)"
            >{{ c.fileName }}</a>
          </div>
        </div>
        <div v-if="!!gradeDocsShcoolText">
          {{gradeDocsShcoolText}}
        </div>
      </v-col>
      <v-col cols="6">
        <p class="overline mb-2">INTYG BIFOGADE AV LÄRLING</p>
        <div
          class="attachment mb-2"
          v-for="g in certificateDocs"
          :key="g.id"
        >
          <v-icon class="flex-grow-0 flex-shrink-0">$sl-file</v-icon>
          <div class="flex-grow-1 flex-shrink-1 attachment-link">
            <a
              v-if="g && g.fileName && g.internalFileName"
              @click="$emit('get-document', g)"
            >{{ g.fileName }}</a>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <p class="overline mb-2">FILER BIFOGADE AV ANVÄNDARE I REGISTRET</p>
        <div
          class="attachment mb-2"
          v-for="attachment in attachmentsDocs"
          :key="attachment.id"
        >
          <v-icon class="flex-grow-0 flex-shrink-0">$sl-file</v-icon>
          <div class="flex-grow-1 flex-shrink-1 attachment-link">
            <a
              v-if="attachment.fileName"
              @click="$emit('get-document', attachment)"
            >{{ attachment.fileName }}</a>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ApplicationDocumentsView',

  props: {
    gradeDocs: {
      type: Array,
      required: true
    },

    certificateDocs: {
      type: Array,
      required: true
    },

    attachmentsDocs: {
      type: Array,
      required: true
    }
  },
  computed:{
    ...mapGetters('application', [ 'selectedApplication',]),
    gradeDocsShcoolText(){
      if(!this.selectedApplication || !this.gradeDocs.length){
        return;
      }
      if(this.selectedApplication.school){
        const { region, municipality, name } = this.selectedApplication.school
        return `${region} - ${municipality} - ${name}`
      }
      if(this.selectedApplication.anotherSchool){
        return 'Skolan finns inte på vår lista'
      }

      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>